module.exports = __webpack_public_path__ + "static/media/arrow.dd268230.svg";